import { render, staticRenderFns } from "./AdminWaitlist.vue?vue&type=template&id=95fbb326&scoped=true"
import script from "./AdminWaitlist.vue?vue&type=script&lang=js"
export * from "./AdminWaitlist.vue?vue&type=script&lang=js"
import style0 from "./AdminWaitlist.vue?vue&type=style&index=0&id=95fbb326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fbb326",
  null
  
)

export default component.exports